import axios from 'axios';
import URLS from '../../util/urls.js';

const state = {
  listaCondominios: [],
  labelQuantidade: '',
  condominioPesquisa: {
    nome: undefined,
    pagina: 0
  },
  condominioSelecionado: {
    id: 0,
    nome: '',
    telefone: '',
    celular: '',
    endereco: '',
    numeroEndereco: '',
    cep: '',
    pontoDeReferencia: '',
    observacoes: '',
    sindico: '',
    telefoneSindico: '',
    celularSindico: '',
    emailSindico: '',
    administradora: { nome: undefined },
    bairro: { id: 0 },
    cidade: { id: 0 },
    estado: { id: 0 },
    imoveis: []
  },
  listaAdministradoras: []
}

const mutations = {
  atualizarListaCondominios(state, payload) {
    if(state.condominioPesquisa.pagina === 0) {
      state.listaCondominios = payload.lista;
    } else {
      state.listaCondominios.push(...payload.lista);
    }
    state.labelQuantidade = `${payload.quantidade} ${payload.quantidade === 1 ? 'Condomínio encontrado' : 'Condomínios encontrados'}`;
  },
  limparCondominiosListados(state) {
    state.listaCondominios = [];
  },
  limparCondominioPesquisa(state) {
    state.condominioPesquisa = {
      nome: undefined,
      pagina: 0
    }
  },
  atualizarCondominioSelecionado(state, payload) {
    state.condominioSelecionado = payload;
  },
  novoCondominio(state) {
    state.condominioSelecionado = {
      id: 0,
      nome: '',
      telefone: '',
      celular: '',
      endereco: '',
      numeroEndereco: '',
      cep: '',
      pontoDeReferencia: '',
      observacoes: '',
      sindico: '',
      telefoneSindico: '',
      celularSindico: '',
      emailSindico: '',
      administradora: { nome: undefined },
      bairro: { id: 0 },
      cidade: { id: 0 },
      estado: { id: 0 },
      imoveis: []
    }
  },
  atualizarListaAdministradoras(state, payload) {
    state.listaAdministradoras = payload.lista;
  },
  limparAdministradoraSelecionada(state) {
    state.condominioSelecionado.administradora = { nome: undefined };
  },
  limparCidadeEBairro(state) {
    state.condominioSelecionado.cidade = { id: 0 };
    state.condominioSelecionado.bairro = { id: 0 };
  }
}

const actions = {
  pesquisarCondominios(context, payload) {
    return axios.post(URLS.CONDOMINIOS_LISTAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarListaCondominios', response.data);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((resultado => {
                if(resultado.status === "SUCESSO") {
                  return context.dispatch('pesquisarCondominios', payload);
                }
              })).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  gravarCondominio(context, payload) {
    return axios.post(URLS.CONDOMINIOS_GRAVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarCondominioSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then((resultado) => {
            if(resultado.status == "SUCESSO") {
              return context.dispatch('gravarCondominio', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  limparCondominiosListados(context) {
    context.commit('limparCondominiosListados');
  },
  limparCondominioPesquisa(context) {
    context.commit('limparCondominioPesquisa');
  },
  recuperarCondominio(context, payload) {
    return axios.post(URLS.CONDOMINIOS_RECUPERAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarCondominioSelecionado', response.data.item);
            break;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('recuperarCondominio', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
    }).catch((error) => {
      throw error;
    });
  },
  novoCondominio(context) {
    context.commit('novoCondominio');
  },
  removerCondominio(context, payload) {
    return axios.post(URLS.CONDOMINIOS_REMOVER, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('novoCondominio');
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO"){
                  return context.dispatch('removerCondominio', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
    }).catch((error) => {
      throw error;
    });
  },
  listarAdministradoras(context, payload) {
    return axios.post(URLS.ADMINISTRADORAS_LISTAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarListaAdministradoras', response.data);
            break;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('listarAdministradoras', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  limparAdministradoraSelecionada(context) {
    context.commit('limparAdministradoraSelecionada');
  },
  limparCidadeEBairro(context) {
    context.commit('limparCidadeEBairro');
  }
}

export default {
  state,
  mutations,
  actions
}